import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "32",
  height: "32",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M26 5a4 4 0 0 1 3.995 3.8L30 9v14a4 4 0 0 1-3.8 3.995L26 27H6.003a4 4 0 0 1-3.995-3.8l-.005-.2V9a4 4 0 0 1 3.8-3.995l.2-.005H26zm0 2H6.003a2 2 0 0 0-1.995 1.85L4.003 9v10.84L10.078 14h2.844l5.719 5.5h1.172l1.561-1.5h2.336L28 22.124V9a2 2 0 0 0-1.85-1.995L26 7zm-4 3a2 2 0 1 1 0 4 2 2 0 0 1 0-4z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }